import React from 'react';
import { Globe, Info } from 'lucide-react';

const TaxResidencySection = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Globe className="w-5 h-5 mr-2 text-indigo-500" />
        Налоговый статус
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Налоговый статус */}
        <div className="col-span-full">
          <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Налоговое резидентство
          </div>
          <div className="grid grid-cols-2 gap-4">
            <label className="flex items-center p-3 bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 cursor-pointer hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-colors">
              <input
                type="radio"
                name="taxResidency"
                value="resident"
                checked={formData.taxResidency === 'resident'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <div className="ml-3">
                <span className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Налоговый резидент РФ
                </span>
                <span className="block text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  Находится в РФ ≥ 183 дней в году
                </span>
              </div>
            </label>
            <label className="flex items-center p-3 bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 cursor-pointer hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-colors">
              <input
                type="radio"
                name="taxResidency"
                value="nonresident"
                checked={formData.taxResidency === 'nonresident'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <div className="ml-3">
                <span className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Налоговый нерезидент РФ
                </span>
                <span className="block text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  Находится в РФ меньше 183 дней в году
                </span>
              </div>
            </label>
          </div>
          {errors.taxResidency && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.taxResidency}
            </p>
          )}
        </div>

        {/* Информационный блок о налоговом резидентстве */}
        <div className="col-span-full mt-3">
          <div className="flex items-start bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
            <Info className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
                О налоговом резидентстве
              </h4>
              <p className="text-xs text-blue-600 dark:text-blue-400">
                Налоговыми резидентами РФ признаются физические лица, которые фактически находятся в Российской Федерации не менее 183 календарных дней в течение 12 следующих подряд месяцев. 
                {formData.taxResidency === 'resident' ? (
                  ' Резиденты уплачивают НДФЛ со всех доходов, полученных как на территории РФ, так и за ее пределами.'
                ) : (
                  ' Нерезиденты уплачивают НДФЛ только с доходов, полученных от источников в РФ, по повышенной ставке 15%.'
                )}
                {formData.taxResidency === 'nonresident' && ' Для нерезидентов налоговые вычеты не предоставляются.'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxResidencySection;